function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,6h30v18H0V6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6h30v4.5H0v-4.5Z",
    style: {
      fill: "#ffd100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30v9H0v-9Z",
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.5h30v4.5H0v-4.5Z",
    style: {
      fill: "#003da5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15L0,24V6l15,9Z",
    style: {
      fill: "#009639"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26,10.904c-2.262.272-3.875,2.326-3.603,4.588.227,1.888,1.715,3.376,3.603,3.603-2.262.627-4.604-.698-5.231-2.96s.698-4.604,2.96-5.231c.742-.206,1.528-.206,2.271,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "5.943 12.353 5.747 12.958 6.261 12.584 6.775 12.958 6.578 12.353 7.093 11.979 6.457 11.979 6.26 11.375 6.064 11.979 5.429 11.979 5.943 12.353",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.26 13.25 6.064 13.854 5.429 13.854 5.943 14.228 5.747 14.833 6.261 14.459 6.775 14.833 6.578 14.228 7.093 13.854 6.457 13.854 6.26 13.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.26 15.125 6.064 15.729 5.429 15.729 5.943 16.103 5.747 16.708 6.261 16.334 6.775 16.708 6.578 16.103 7.093 15.729 6.457 15.729 6.26 15.125",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.457 17.604 6.26 17 6.064 17.604 5.429 17.604 5.943 17.978 5.747 18.583 6.261 18.209 6.775 18.583 6.578 17.978 7.093 17.604 6.457 17.604",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/KM.3015758a51d2af96facfafd30aeaded1.svg";
export { ForwardRef as ReactComponent };